import { render, staticRenderFns } from "./TicketIndex.vue?vue&type=template&id=32dd8900&scoped=true"
import script from "./TicketIndex.vue?vue&type=script&lang=js"
export * from "./TicketIndex.vue?vue&type=script&lang=js"
import style0 from "./TicketIndex.vue?vue&type=style&index=0&id=32dd8900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dd8900",
  null
  
)

export default component.exports